"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TOOLTIP_Z_INDEX = exports.TOOLTIP_PROPS = exports.TOOLTIP_CONTENT_TYPE = exports.LINK_TYPE = exports.ICON_TYPE = exports.BAGGAGETYPE_COLOR = void 0;
var TRANSLATION = {
  handCarry: 'Carry-on Baggage',
  checkedBaggage: 'Checked Baggage',
  sportsEquip: 'Sports Equipment',
  toolTipTitle: 'What is a hand carry?',
  toolTipLabel: 'This is a bag you carry on board the aircraft. You must store it in the overhead compartment.',
  golf: 'Golf',
  skisSnowboard: 'Skis/Snowboard',
  surfBoard: 'Surfboard',
  cricket: 'Cricket',
  bicycle: 'Bicycle',
  divingGear: 'Diving Gear',
  readMore: 'Read More'
};
exports.TRANSLATION = TRANSLATION;
var BAGGAGETYPE_COLOR = {
  checkedBaggage: {
    baggageHeadingColor: 'blueMedium',
    baggageTypeColor: 'blueActive',
    toolTipColor: ''
  },
  handCarry: {
    baggageHeadingColor: 'secondaryBlue',
    baggageTypeColor: 'secondaryLight',
    toolTipColor: 'secondaryBlue'
  },
  sportsEquip: {
    baggageHeadingColor: 'yellow',
    baggageTypeColor: 'yellowLight',
    toolTipColor: 'yellow'
  }
};
exports.BAGGAGETYPE_COLOR = BAGGAGETYPE_COLOR;
var TOOLTIP_CONTENT_TYPE = {
  list: 'list',
  icons: 'icons',
  text: 'text',
  link: 'link'
};
exports.TOOLTIP_CONTENT_TYPE = TOOLTIP_CONTENT_TYPE;
var ICON_TYPE = {
  info: {
    color: '',
    type: 'InfoIcon',
    size: 'titleSmall'
  },
  sports: {
    color: 'greyDark',
    type: '',
    size: 'titleSmall'
  }
};
exports.ICON_TYPE = ICON_TYPE;
var LINK_TYPE = {
  info: {
    color: 'tertiaryRed',
    size: 'small'
  }
};
exports.LINK_TYPE = LINK_TYPE;
var TOOLTIP_Z_INDEX = 1000;
exports.TOOLTIP_Z_INDEX = TOOLTIP_Z_INDEX;
var TOOLTIP_PROPS = {
  Z_INDEX: 1000,
  WIDTH: 280
};
exports.TOOLTIP_PROPS = TOOLTIP_PROPS;